// Formatting helpers for per-post engagement metrics.

/**
 * Abbreviate a count the way social platforms do: 56 → "56", 1_200 → "1.2K",
 * 3_400_000 → "3.4M". One decimal place, trailing ".0" trimmed. Non-finite or
 * negative inputs collapse to "0".
 */
export function formatCount(n: number): string {
  if (!Number.isFinite(n) || n < 0) return "0";
  if (n >= 1_000_000) return `${trimOneDecimal(n / 1_000_000)}M`;
  if (n >= 1_000) return `${trimOneDecimal(n / 1_000)}K`;
  return String(Math.round(n));
}

/** Round to one decimal and drop a trailing ".0" (1.0 → "1", 1.2 → "1.2"). */
function trimOneDecimal(value: number): string {
  const rounded = Math.round(value * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}
